const LINKS = [
	{
		label: 'О себе',
		link: '#about',
	},
	{
		label: 'Карьера',
		link: '#career',
	},
	{
		label: 'Проекты',
		link: '#projects',
	},
]

export { LINKS }
